export default __webpack_public_path__ + "static/media/cs-a018-10.77ec735f.svg";